import { Dialog,Button, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { I18n } from "aws-amplify/utils";
// Dialog for confirmation
const ConfirmationReassign = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{I18n.get("Confirm Action")}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {I18n.get("Are you sure you want to reassign these alarms?")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {I18n.get("No")}
        </Button>
        <Button onClick={onConfirm} color="primary">
          {I18n.get("Yes")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationReassign;